import React, { memo, useContext, useState } from 'react';
import { Box, Drawer, IconButton, Popover, Tooltip } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { HelpModeContext, helpModes, ModalsContext } from './App';
import { mutationTypes } from './mutationUtils';
import ExplanationSpiranteMutation from './ExplanationSpiranteMutation';
import ExplanationHardMutation from './ExplanationHardMutation';
import ExplanationMixedMutation from './ExplanationMixedMutation';
import ExplanationSoftMutation from './ExplanationSoftMutation';
import DialogTitleForMutation from './DialogTitleForMutation';
import ExplanationNoun_MS_FP_NounMutation from './ExplanationNoun_MS_FP_NounMutation';
import ExplanationNoun_FS_MP_NounMutation from './ExplanationNoun_FS_MP_NounMutation';
import ExplanationAdjectiveMutation from './ExplanationAdjectiveMutation';
import { useTranslation } from 'react-i18next';

const BtnOpenMutation = (props) => {

    const { t } = useTranslation();
  
    const { mutationType } = props;

    const modals = useContext(ModalsContext);
    const [ helpMode ] = useContext(HelpModeContext);

    const getModalRef = () => {
      if (mutationType === mutationTypes.SPIRANTE) {
        return modals.spirante;
      } else if (mutationType === mutationTypes.HARD) {
        return modals.hard;
      } else if (mutationType === mutationTypes.MIXED) {
        return modals.mixed;
      } else if (mutationType === mutationTypes.SOFT) {
        return modals.soft;
      } else if (mutationType === mutationTypes.INCOMPLETE) {
        return modals.incomplete;
      } else if (mutationType === mutationTypes.SOFT_INCOMPLETE) {
        return modals.soft_incomplete;
      } else if (mutationType === mutationTypes.SOFT_CONDITIONAL) {
        return modals.soft_conditional;
      } else {
        throw Error(`Mutation type not handled: ${mutationType}`);
      }
    };

    const [ anchorEl, setAnchorEl ] = useState(null);

    const closePopover = () => {
      setAnchorEl(null);
    };

    const openWidget = (event) => {

      if (helpMode === helpModes.POPOVER) {
        setAnchorEl(event.currentTarget);

      } else if (helpMode === helpModes.DRAWER) {
        setIsDrawerOpen(true);

      } else if (helpMode === helpModes.MODAL) {
        getModalRef().current.open();

      } else {
        throw Error(`Help mode not handled: ${helpMode}`);
      }
    };

    const [ isDrawerOpen, setIsDrawerOpen ] = useState(false);

    const closeDrawer = (event) => {
      if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
      }

      setIsDrawerOpen(false);
    };

    return <>
      <Tooltip title={t(`modal_title_${mutationType}`.toLowerCase())}>
        <IconButton
          className={`mutation-bg modal-mutation-btn ${mutationType}`}
          onClick={event => openWidget(event)}
          size="large">
          <FiberManualRecordIcon />
        </IconButton>
      </Tooltip>

      {helpMode === helpModes.POPOVER &&
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={closePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <DialogTitleForMutation mutationType={mutationType} closeFn={closePopover} />
        <Box sx={{
          overflowY: 'auto',
        }}>
          {mutationType === mutationTypes.SPIRANTE && <ExplanationSpiranteMutation />}
          {mutationType === mutationTypes.HARD && <ExplanationHardMutation />}
          {mutationType === mutationTypes.MIXED && <ExplanationMixedMutation />}
          {mutationType === mutationTypes.SOFT && <ExplanationSoftMutation />}
          {mutationType === mutationTypes.INCOMPLETE && <ExplanationNoun_MS_FP_NounMutation />}
          {mutationType === mutationTypes.SOFT_INCOMPLETE && <ExplanationNoun_FS_MP_NounMutation />}
          {mutationType === mutationTypes.SOFT_CONDITIONAL && <ExplanationAdjectiveMutation />}
        </Box>
      </Popover>}

      {helpMode === helpModes.DRAWER &&
      <Drawer anchor={'right'} open={isDrawerOpen} onClose={event => closeDrawer(event)}>
        <DialogTitleForMutation mutationType={mutationType} closeFn={closeDrawer} />
        <Box sx={{
          overflowY: 'auto',
        }}>
          {mutationType === mutationTypes.SPIRANTE && <ExplanationSpiranteMutation />}
          {mutationType === mutationTypes.HARD && <ExplanationHardMutation />}
          {mutationType === mutationTypes.MIXED && <ExplanationMixedMutation />}
          {mutationType === mutationTypes.SOFT && <ExplanationSoftMutation />}
          {mutationType === mutationTypes.INCOMPLETE && <ExplanationNoun_MS_FP_NounMutation />}
          {mutationType === mutationTypes.SOFT_INCOMPLETE && <ExplanationNoun_FS_MP_NounMutation />}
          {mutationType === mutationTypes.SOFT_CONDITIONAL && <ExplanationAdjectiveMutation />}
        </Box>
      </Drawer>}
    </>;
  }
;

export default memo(BtnOpenMutation);
